import fipeApi from "../../config/external/fipeApi";

const GetCarBrands = async (carTypeValue: string) => {
   const carBrands = await fipeApi.get(`/${carTypeValue}/marcas.json`);
   return carBrands.data;
};

export default GetCarBrands;
